// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1mouv77o{margin-block:var(--ds-space-025,2px)}._18l8n7od [data-section]:first-of-type{border-block-start:unset}\n._18m91wug{overflow-y:auto}\n._c71lnklw{max-height:20pc}", ""]);
// Exports
module.exports = exports;
